<div class="row admin">
  <p class="admin"><b>{{ 'admin.land.new' | translate }}</b></p>
</div>
<div class="row admin">
    <div class="col-md-2 pl-0 mb-0"><p class="admin mt-0"><b>{{ 'admin.land.column.de' | translate }}</b></p></div>
    <div class="col-md-2 pl-0 mb-0"><p class="admin mt-0"><b>{{ 'admin.land.column.fr' | translate }}</b></p></div>
    <div class="col-md-2 pl-0 mb-0"><p class="admin mt-0"><b>{{ 'admin.land.column.it' | translate }}</b></p></div>
    <div class="col-md-1 pl-0 mb-0"><p class="admin mt-0"><b>{{ 'admin.land.column.sort' | translate }}</b></p></div>
    <div class="col-md-1 pl-0 mb-0"><p class="admin mt-0"><b>{{ 'admin.land.column.zulassungsLand' | translate }}</b></p></div>
    <div class="col-md-1 pl-0 mb-0"><p class="admin mt-0"><b>{{ 'admin.land.column.importLand' | translate }}</b></p></div>
    <div class="col-md-0.5 pl-0 mb-0"><p class="admin mt-0">
      <b [matTooltip]="'admin.land.column.nutztier.tooltip' | translate" matTooltipPosition="above">
        {{ 'admin.land.column.nutztier' | translate }}
      </b>
    </p></div>
    <div class="col-md-0.5 pl-0 mb-0"><p class="admin mt-0">
      <b [matTooltip]="'admin.land.column.heimtier.tooltip' | translate" matTooltipPosition="above">
        {{ 'admin.land.column.heimtier' | translate }}
      </b>
    </p></div>
</div>
<div class="row admin">
  <form [formGroup]="newLandForm()" (ngSubmit)="submit()">
    <div class="col-md-2 pl-0 mb-0">
      <input id="bezeichnungDe_new" class="admin-settings" formControlName="bezeichnungDe_new" maxlength="255">
    </div>

    <div class="col-md-2 pl-0 mb-0">
      <input id="bezeichnungFr_new" class="admin-settings" formControlName="bezeichnungFr_new" maxlength="255">
    </div>

    <div class="col-md-2 pl-0 mb-0">
      <input id="bezeichnungIt_new" class="admin-settings" formControlName="bezeichnungIt_new" maxlength="255">
    </div>

    <div class="col-md-1 pl-0 mb-0">
      <input id="sortierung_new" class="admin-settings" formControlName="sortierung_new">
    </div>

    <div class="col-md-1 pl-0 mb-0">
      <input type="checkbox" id="zulassungsLand_new" formControlName="zulassungsLand_new">
    </div>

    <div class="col-md-1 pl-0 mb-0">
      <input type="checkbox" id="importLand_new" formControlName="importLand_new">
    </div>

    <div class="col-md-0.5 pl-0 mb-0">
      <input type="checkbox" id="nutztier_new" formControlName="nutztier_new">
    </div>

    <div class="col-md-0.5 pl-0 mb-0">
      <input type="checkbox" id="heimtier_new" formControlName="heimtier_new">
    </div>

    <div class="col-md-2 pl-0 mb-0">
      <button class="btn btn-sm admin-settings" type="submit" [disabled]="newLandForm().invalid">
        <i class="fa fa-check"></i>
      </button>

      <button class="btn btn-sm admin-settings" type="button" [title]="'global.cancel' | translate" (click)="reset()">
        <i class="fa fa-times"></i>
      </button>
    </div>
  </form>
</div>
